type TAverage = Record<string, number>;

type TGroupingTypes = Array<'networks' | 'cities' | 'markets' | 'mediatypes'>;

interface IAudienceConcentrationGroupingAPI {
  unit_ids: number[];
  plan_ids: number[];
  deal_ids: number[];
  lineitem_ids: number[];
  demographic_ids: number[];
  from_date: string;
  to_date: string;
  grouping_types: TGroupingTypes;
}

export interface IAudienceConcentrationGroupingAPIObject {
  unitIDs: IAudienceConcentrationGroupingAPI['unit_ids'];
  planIDs?: IAudienceConcentrationGroupingAPI['plan_ids'];
  dealIDs?: IAudienceConcentrationGroupingAPI['deal_ids'];
  lineItemIDs?: IAudienceConcentrationGroupingAPI['lineitem_ids'];
  demographicIDs: IAudienceConcentrationGroupingAPI['demographic_ids'];
  fromDate: IAudienceConcentrationGroupingAPI['from_date'];
  toDate: IAudienceConcentrationGroupingAPI['to_date'];
  groupingTypes: IAudienceConcentrationGroupingAPI['grouping_types'];
}

export class AudienceConcentrationGroupings {
  locationsAverages?: TAverage;

  marketsAverages?: TAverage;

  mediaTypesAverages?: TAverage;

  networkAverages?: TAverage;

  constructor(
    locationsAverages: TAverage = null,
    marketsAverages: TAverage = null,
    mediaTypesAverages: TAverage = null,
    networkAverages: TAverage = null,
  ) {
    this.locationsAverages = locationsAverages;
    this.marketsAverages = marketsAverages;
    this.mediaTypesAverages = mediaTypesAverages;
    this.networkAverages = networkAverages;
  }

  static fromApi(apiObject) {
    return new AudienceConcentrationGroupings(
      apiObject.locations_averages,
      apiObject.markets_averages,
      apiObject.mediatypes_averages,
      apiObject.network_averages,
    );
  }

  static toApi(obj: IAudienceConcentrationGroupingAPIObject): IAudienceConcentrationGroupingAPI {
    const newObj = {
      unit_ids: obj.unitIDs ?? null,
      plan_ids: obj.planIDs ?? null,
      deal_ids: obj.dealIDs ?? null,
      lineitem_ids: obj.lineItemIDs ?? null,
      demographic_ids: obj.demographicIDs ?? [],
      from_date: obj.fromDate,
      to_date: obj.toDate,
      grouping_types: obj.groupingTypes,
    };
    return newObj;
  }
}
